import React from "react";

/**
 * component svg 
 */
const Ghost = function (props) {

    return (
        <svg version="1.1" id="ghost" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 1000 1000">
            <path className="st0-ghost" d="M949.5,759c-34.3-97-89.7-188.9-98.5-293.2c0-0.3,0-0.6,0-0.9s-0.8-0.1-0.1-1c-5.7-99-58.2-209-174.7-205.1
                C550.8,263,499.5,395.2,512,505.6c16.2,110.9,19.6,217.5,6.4,329"/>
            <ellipse transform="matrix(1.122617e-02 -0.9999 0.9999 1.122617e-02 200.0576 961.9827)" cx="586.5" cy="379.8" rx="21.8" ry="27.4"/>
            <ellipse transform="matrix(1.122617e-02 -0.9999 0.9999 1.122617e-02 329.3011 1095.6136)" cx="718.6" cy="381.3" rx="21.8" ry="29.1"/>
            <path d="M678.8,453.7c2.3,22-9.1,49.7-35.9,45.1c-26.8-4.6-21.4-27.8-21.6-47.3c-0.2-19.5-3-38.9,20.7-41.1S676.5,431.7,678.8,453.7
                z"/>
            <path className="st1-ghost" d="M407.8,331.6c31.9-17.6,51.3-40.8,51.3-66.3c0-55.2-91.5-100-204.3-100s-204.3,44.8-204.3,100
                s91.5,100,204.3,100c33.7,0,65.5-4,93.6-11.1c21.9,31.4,51.9,40.2,98.4,39.6C417.6,378.1,408.1,355.2,407.8,331.6z"/>
            <text transform="matrix(1 0 0 1 159.4091 299.821)" className="st2-ghost">404</text>
            <path className="st0-ghost" d="M518.4,834.6l18.3-11.6c25.3-16.1,57.5-16.4,83.2-0.9l0,0c25.3,15.3,56.9,15.2,82.1-0.2l33.1-20.3
                c34.3-21,76.8-23.7,113.5-7.1l0,0c37.7,17,82.1,1.4,100.8-35.5l0,0"/>
        </svg>
    );
};

export default Ghost;